module.exports = __webpack_public_path__ + "static/media/181.85e9c32a.mp3";